'use strict';

import ajax from '../../ajax';
import image from './image';
import productSet from './productSet';
import progress from '../../progress';
import productStoreInventory from '../../storeinventory/product';
import socialShareIcons from './socialShareIcons';
import util from '../../util';
import recommendations from './recommendations';
import imagesLoaded from 'imagesloaded';
import customModal from '../../modal';
import customDropdown from '../../custom-dropdown';
import productDetail from '../../pages/product-detail';
import copyTextClipboard from '../../copy-text-clipboard';

/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 **/
function pdpMobileColorSwatchesCarousel() {
	var colorSwatchSlider = $('.swatches.color:not(.sticky-swatches)'),
		isShadesEnabled = $('.color-filter-wrapper .color-filter-attr').length ? $('.color-filter-wrapper .color-filter-attr')[0].innerText === localStorage.getItem('selColorCat') : false;
	
	if ($(window).width() <= 768 && colorSwatchSlider.length && (isShadesEnabled || !$('.color-filter-wrapper .color-filter-attr').length)) {

		colorSwatchSlider.not('.slick-initialized').slick({
			arrows: true,
			dots: false,
			infinite: false,
			centerMode: false,
			variableWidth: true,
			swipeToSlide: true,
			slidesToShow: 5,
			slidesToScroll: 5
		});

		// get the selected variant
		var selectedVariant = $('.swatches.color:not(.sticky-swatches) li.selected');

		// know it's index
		var indexOfSelected = selectedVariant.closest('.slick-slide').attr('data-slick-index');

		// automatically slide to variant upon page load
		colorSwatchSlider.slick('slickGoTo', indexOfSelected, false);
	} else {	
		if (colorSwatchSlider.hasClass('slick-initialized')) {
			colorSwatchSlider.slick('destroy');
		}
	}
}

function productSetColorSwatchesCarousel() {
	var colorSwatchSlider = $('#product-set .swatches.color:not(.sticky-swatches)');
	if($(window).width() <= 768 && colorSwatchSlider.length) {

		colorSwatchSlider.not('.slick-initialized').slick({
			arrows: true,
			dots: false,
			infinite: true,
			centerMode: true,
			variableWidth: true,
			swipeToSlide: false,
			slidesToShow: 2,
			slidesToScroll: 2
		});
		// automatically slide to selected variant
		colorSwatchSlider.each(function() {
			var selectedVariant = $(this).find('li.selected');
			var indexOfSelected = selectedVariant.closest('.slick-slide').attr('data-slick-index');
			$(this).slick('slickGoTo', indexOfSelected, false);
		});
	} else {
		if (colorSwatchSlider.hasClass('slick-initialized')) {
			colorSwatchSlider.slick('destroy');
		}
	}
}

// Sticky Scroll Image container
if ($('.pdp-ver-one .product-image-container').length) {
	var stickySidebar = new StickySidebar('.pdp-ver-one .product-image-container', {
		topSpacing:  $('.pdp-page #header-bottom-notification-message').length ? 22 : 25,
		bottomSpacing: 52,
		resizeSensor: true,
		innerWrapperSelector: '.sidebar__inner'
	});
}
function resizeStickySidebar() {
	if ($(window).width() < 991 && $('.pdp-ver-one .product-image-container').length && stickySidebar) {
		stickySidebar.destroy();
	}
}

function updateContent(href,pid) {
	var $pdpForm = $('.pdpForm'),
		qty = $pdpForm.find('select[name="Quantity"] option:selected').val(),
		activeThumbnail = $('#thumbnails .slick-slide').first().attr('data-slick-index');
	
	var repleCycle = $('select#replencycle option:selected').length > 0 ? $('select#replencycle option:selected').val() : '0';

	var params = {
		repleCycle : repleCycle,
		Quantity: isNaN(qty) ? '1' : qty,
		format: 'ajax',
		productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
	};
	ajax.load({
		url: util.appendParamsToUrl(href, params),
		target: $('#product-content'),
		callback: function () {
			if (SitePreferences.STORE_PICKUP) {
				productStoreInventory.init();
			}
			initColorCategoryFilter();
			var stickyElememt = $('#product-content').find('.sticky-buy-section');
			var stickyContent = stickyElememt.html();
			var ajaxFlag = true;
			stickyElememt.html('');
			updatePdpStickyContent(stickyContent);
			updateContentSticky(stickyContent);
			
			socialShareIcons();
			recommendations.init();
			
			if ($('#pdp-top-quantity').length) {
				$('select').selectmenu({
					width: false,
					position: {
						my: "left top",
						at: "left bottom",
						collision: "flip flip"
					}
				});
				$("#pdp-top-quantity-menu").parent().addClass("pdp-qty-width");
				syncQtyDropdownValue($('.quantity-dropdown'));
			}
			
			initColorShadesSlider();
			customDropdown.init();
			updateReplanishCycle();
			
			imagesLoaded('.product-thumbnails .productthumbnail').on('done', function () {
				$('.fade-circle').removeClass('hidden');
				$(document).trigger("gtvariationchange");
			});
			scrollToActiveSizeVariant();
			
			// scroll to selected category
			var selectedVariant = $('#product-content .pdp-color-category-filter li.selected'); // get the selected variant
			var indexOfSelected = selectedVariant.closest('.slick-slide').attr('data-slick-index'); // know it's index
			var updatedIndex  = indexOfSelected > 1 ? indexOfSelected - 1 : indexOfSelected;
			indexOfSelected > 1 && $('#product-content .pdp-color-category-filter').slick('slickGoTo', updatedIndex, false);

			checkVariantScrollReachedEnd();
			applyTransparentGradientOnScroll();
			
			// Enable the add-to-cart button
			if ($('.disabled-onload') && $('.disabled-onload').length > 0){
				$('.disabled-onload').removeClass('disabled-onload');
			}
			setTimeout(() => {
				// initialize ui-accordion
				productDetail.init();
				// reinit stickySidebar after variation change
				if ($(window).width() >= 991 && $('.pdp-ver-one .product-image-container').length) {
					stickySidebar = new StickySidebar('.pdp-ver-one .product-image-container', {
						topSpacing: $('.pdp-ver-one #header-bottom-notification-message').length ? 22 : 25,
						bottomSpacing: 52,
						resizeSensor: true,
						innerWrapperSelector: '.sidebar__inner'
					});
				}
				image(); // removed image() params to enable zoom feature
			}, 2000);
			copyTextClipboard.init();
		},
	})
}

function updateContentSticky(stickContent) {
	var $pdpForm = $('.pdpForm');
	var qty = $('#product-content-sticky').find('select[name="Quantity"] option:selected').val();

	$('#product-content-sticky').html(stickContent);

	if (SitePreferences.STORE_PICKUP) {
		productStoreInventory.init();
	}
	$('select').selectmenu({
		width: false,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "flip flip"
		}
	});
	$("#pdp-top-quantity-menu").parent().addClass("pdp-qty-width");
	syncQtyDropdownValue($('.quantity-dropdown'));
	socialShareIcons();
	
}

//product set total
function getProductSetTotal() {	return new Promise(function (resolve, reject) {
	var totalSalePrice = 0, 
	totalStdPrice = 0, 
	tempNumSale = 0, 
	tempNumStd = 0;

	$('.product-set-list  .product-price-value').each(function(){
		//Sale Price
		tempNumSale = $(this).find(".price-sales").text();
		tempNumSale = tempNumSale.replace(/[^0-9]+/g,"");
		tempNumSale = parseFloat(tempNumSale/100);
		totalSalePrice += tempNumSale;
		//Std Price
		tempNumStd = $(this).find(".price-standard").text() ? $(this).find(".price-standard").text() : $(this).find(".price-sales").text();
		tempNumStd = tempNumStd.replace(/[^0-9]+/g,"");
		tempNumStd = parseFloat(tempNumStd/100);
		totalStdPrice += tempNumStd;
	});
	
	totalSalePrice = totalSalePrice.toFixed(2);
	totalStdPrice = totalStdPrice.toFixed(2);	
	
	var currencyLocale = window.User.locale.replace(/_/g, '-');
	var formattedSalePrice = util.getFormattedCurrency(currencyLocale,  window.User.currencyCode, totalSalePrice);	
	var formattedStdPrice = util.getFormattedCurrency(currencyLocale,  window.User.currencyCode, totalStdPrice);
	
	return resolve(totalSalePrice==totalStdPrice ? {'salesPrice' : formattedSalePrice} : {'salesPrice':formattedSalePrice, 'standeredPrice':formattedStdPrice});

	});
}

//product set button enable/disable
function setAddToCartPS() {
	var avail = "",
	flag = 0;
	$('.product-set-list  .product-set-item').each(function(){
		//avail
		avail = $(this).find("input[name=availability]").val();
		flag = avail == "NOT_AVAILABLE" ? 1 : flag;
	});
	
	if(flag == 1) {
		$('#add-all-to-cart').attr('disabled', 'disabled');
		$('.bundle-sticky-buy-container .add-to-cart-in-stock').addClass('disabled');
		$('.bundle-sticky-buy-container .add-to-cart').attr('disabled', 'disabled');
		$('#findstore-wrapper').removeClass('visually-hidden');
	} else {
		$('#add-all-to-cart').removeAttr('disabled');
		$('.bundle-sticky-buy-container .add-to-cart-in-stock').removeClass('disabled');
		$('.bundle-sticky-buy-container .add-to-cart').removeAttr('disabled');
		$('#findstore-wrapper').addClass('visually-hidden');
	}
}

function updateSetContent($ele, href) {
	var $productSetItemCtnr = $ele.parents(".product-set-item"),
		qty = $productSetItemCtnr.find('form select[name="Quantity"]').val();

	progress.show($productSetItemCtnr);

	$.get(util.appendParamsToUrl(href, {
		Quantity: isNaN(qty) ? '1' : qty,
		format: "ajax",
		setproduct: true
	})).done(function (html) {
		$productSetItemCtnr.html(html);
		// re-initialize all the selectmenu 
		$('select').selectmenu({
			width: false,
			position: {
				my: "left top",
				at: "left bottom",
				collision: "flip flip"
			}
		});
		
		getProductSetTotal().then(function(productPriceDisp){
			if(window.isProductSetCustomPrice === false){
				$('#product-set .price-details .salesprice').html(productPriceDisp.salesPrice);
				$('.bundle-sticky-buy-container .product-price .salesprice').html(productPriceDisp.salesPrice);
			}
			if(productPriceDisp.standeredPrice) {
				$('.price-standard-set').text(productPriceDisp.standeredPrice);
			} else {
				$('#product-set .price-details .salesprice-std').html("");
				$('.bundle-sticky-buy-container .product-price .salesprice-std').html("");
			}			
			setAddToCartPS();
			productSetColorSwatchesCarousel();
		});

	});
}

function updatePdpStickyContent(stickyContent) {
	$(".stick-buy-container .product-details").html(stickyContent)
	$('select').selectmenu({
		width: false,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "flip flip"
		}
	});
}

/**
 * @description update sticky buy swatch dropdown
 **/
function updateStickyBuySwatchDropdown() {
	var $swatchsDropdown = $('.stick-buy-container .swatches-dropdown'),
		$selectedSwatch = $('.stick-buy-container #pdp-swatches li.selected .swatchanchor');
	$swatchsDropdown.html($selectedSwatch.html());
	$swatchsDropdown.off().on('click', function () {
		$(this).toggleClass('active');
		$(this).siblings('#pdp-swatches').toggleClass('active').css('width', $swatchsDropdown.innerWidth());
	});
}

function syncQtyDropdownValue($dropdownElem) {
	$dropdownElem.on('selectmenuchange change', function () {
		$dropdownElem.val($(this).val());
		$dropdownElem.selectmenu().selectmenu('refresh');
	});
}

function updateQuantityOnChange() {
	var $quantityDropdown = $('.quantity-dropdown')
	$quantityDropdown.selectmenu({
		width: false,
		position: {
			my: "left top",
			at: "left bottom",
			collision: "flip flip"
		}
	});
	syncQtyDropdownValue($quantityDropdown);
}

function updateReplanishCycle() {
	//On Change Select in PDP
	$('.replenishmentCycle').on('selectmenuchange change', function () {
		var footerURL = window.location.href;
		var selection = $(this).val();

		if (window.User.isCustomerAuthenticated == false && selection != 0) {
			$('.replenishmentCycle').val('0');
			$('.replenishmentCycle').selectmenu('refresh');

			$.ajax({
				url: Urls.replenishmentLogin,
				success: function (response) {
					if($('.replenishment-onchange').length > 0) {
						if ($('.quickview-modal').length > 0) {
							customModal.createCustomModal('replenishment-onchange-modal quickview-replenishment', '#modal-custom-placeholder');
						} else {
							customModal.createCustomModal('replenishment-onchange-modal', '#modal-custom-placeholder');
						}
						$('.replenishment-onchange-modal .modal-body').html(response).scrollBox();
					}

					$('.modal-btn-signin').click(function () {
						var urlLink = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
						window.location = urlLink;
					});

					$('.modal-btn-register').click(function () {
						var urlLink = util.appendParamToURL(Urls.showCreateAccount, 'original', footerURL);
						window.location = urlLink;
					});
				}
			});
		} else {
			var $dropdownElem = $('.replenishmentCycle');
			$dropdownElem.val(selection);
			$("input[name='replenishmentCycle']").val(selection);
			$dropdownElem.selectmenu().selectmenu('refresh');
		}
	});
}

function initColorCatFiltersEvents() {
	// select All shades by default
	if($('.color-filter-wrapper .color-filter-attr').length) {
		localStorage.setItem('selColorCat', $('.color-filter-wrapper .color-filter-attr')[0].innerText);
	}	
	$(document).on('click', '.color-filter-wrapper .color-filter-attr', function(e) {
		e.stopPropagation();
		if ($('.swatches.color:not(.sticky-swatches) li').length) {
			var selectedColorCat = localStorage.getItem('selColorCat');			
            var selectedValue = $(this).text();			

			localStorage.setItem('selColorCat', selectedValue);
			$('.color-filter-wrapper .color-filter-attr').removeClass('selected');
			$(this).addClass('selected');
			
			if (selectedColorCat && selectedColorCat != selectedValue) {
                // track event
                if ($('.quickview-modal').length === 0 && window.dataLayer) {
                    window.dataLayer.push(util.filterObj({
                        "event": "productInteraction",
                        "productCategory": $(".breadcrumb").find(".breadcrumb-element:eq(2)").text().trim(),
                        "productSubCategory": $(".breadcrumb").find(".breadcrumb-element:eq(3)").text().trim(),
                        "productName": $(".product-detail .product-name").text(),
                        "pageCategory": 'Product Page',
                        "productId": $('#pid').val(),
                        "interactionType": "choice of shade"
                    }));
                }
            }			
									
			$('.swatches.color:not(.sticky-swatches) li').filter(function() {
				var $this = $(this);
				var curVal = $this.data('ccatvalues') || '';
				var curValArr = curVal.split(", ");
				if (curVal && curValArr.includes(selectedValue)) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});
			
			if ($('.swatches.color li:visible').length && !$('.swatches.color li:visible').hasClass('selected')) {
				var firstSwatch;
				// select first swatch based on filtered shade
				if($('.swatches.color li:visible').hasClass('selectable')) {
					firstSwatch = $('.swatches.color li.selectable:visible')[0]; // select in-stack swatch
					
					$(firstSwatch).find('.swatchanchor').trigger('click');
				}else {
					firstSwatch = $('.swatches.color li:not(.selectable):visible')[0]; // select OOS swatch
					
					$(firstSwatch).find('.swatchanchor').trigger('click');
				}
			}
		}
	});
}

function initColorCategoryFilter() {
	var selectedColorCat = localStorage.getItem('selColorCat');
	
	if (selectedColorCat) {		
		var prevSelectedFilter = $(".color-filter-wrapper li.color-filter-attr:contains('" + selectedColorCat +"')");
		
		if (prevSelectedFilter.length && prevSelectedFilter.length > 1) {
			prevSelectedFilter.each((id, elem) => {	
				let innerDomText = 	elem.innerText;
				if (innerDomText.toUpperCase() === selectedColorCat.toUpperCase()) {					
					elem.click();
					return;
				} 
			  }); 
		}else if (prevSelectedFilter.length) {
			prevSelectedFilter.click();
		}
	}
}

function isOverflowColorShade() {
	var $colorCategoryWrapper = $('.pdp-color-category-filter:not(.slick-initialized)'),
		$colorCategoryTile = $('.color-filter-wrapper .pdp-color-category-filter:not(.slick-initialized) li.color-filter-attr'),
		totalWidth = 0;

	if($colorCategoryWrapper.length && $colorCategoryTile.length) {
		$colorCategoryTile.each(function(index) {
			totalWidth += $(this).outerWidth();
		});
		return $colorCategoryWrapper.width() <= totalWidth;
	}	
}

function initColorShadesSlider() {
	var $colorCategory = $('.pdp-color-category-filter');
	if($colorCategory.length && isOverflowColorShade()) {
		$colorCategory.not('.slick-initialized').slick({
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 2,
			centerMode: false,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: false,
						centerMode: false 
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						infinite: false,
						centerMode: false
					}
				}
			]
		});
	}	
}

/**
 * @description
 * Apply transparent gradient at the right side of the color and the size variant(PDP & Quickview).
 * Trigger on document ready, window resize and window orientationchange.
 **/
 function applyTransparentGradient() {
	var $scrollableElement = $(document).find('.product-info .swatches.size.mobile-scrollable');
	if($scrollableElement.length && $(window).width() < 768) {
		($scrollableElement.get(0).scrollWidth > $scrollableElement.outerWidth()) ? $(".transparent-gradient").show() : $(".transparent-gradient").hide();		
	}
}

/**
 * @description
 * Apply transparent gradient at the right side of the color and the size variant on scroll of pdp-swatches(PDP & Quickview).
 **/
function applyTransparentGradientOnScroll() {
	$('.product-info .swatches.size.mobile-scrollable').on('scroll', function() {
		checkVariantScrollReachedEnd();	
	});
}

// to check variant reach to the end 
function checkVariantScrollReachedEnd() {
	var $elem = $('.swatches.size.mobile-scrollable');
	var offset = 0;
	var scrollLeft,
		ElemWidth,
		scrollWidth;
	if($elem.length) {
		scrollLeft = $elem.scrollLeft(),
		ElemWidth = $elem.width(),
		scrollWidth = $elem.get(0).scrollWidth;
		// check scroll reached to the right end
		if (scrollWidth - scrollLeft - ElemWidth === offset) {
			$(".transparent-gradient").hide();
		} else {
			$(".transparent-gradient").show();
		}
	}	
}

// scroll to activated swatch, to get better visiblity in the viewport
function scrollToActiveSizeVariant() {
	var $scrollableArea = $('.swatches.size.mobile-scrollable'),
		$activeEle;
		if($scrollableArea.length) {
			$activeEle = $scrollableArea.find('li.selected').find('.swatchanchor');
			if($scrollableArea.outerWidth() <= $activeEle.offset().left) {
				$scrollableArea.animate({scrollLeft: $scrollableArea.scrollLeft() + $activeEle.offset().left}, 500);
				checkVariantScrollReachedEnd();
			}
		}
}

/**
 * @private
 * @function
 * @description screen resize handler.
 */
 function initResizeHandler() {
	// store the window width
	var windowWidth = $(window).width();
	$(window).on('resize orientationchange', function () {
		// check window width has actually changed and it's not just iOS triggering a resize event on scroll
		if ($(window).width() != windowWidth) {
			productSetColorSwatchesCarousel();
			initColorShadesSlider();
		}
		applyTransparentGradient();
	});
}

// re-initialize Einstein Recommendation carousel
function initEinsteinRecommendations() {
	$(window).on("load", function() {
		setTimeout(function() {
			recommendations.init();
			// to reinit recommended product's quantity dropdown 
			$('.carousel-recommendations select').selectmenu();
		}, 5000);	
	});
}

export default {
		function () {
		// With experience-main-productdetail class, all events and logic are in the same place and will work for the PDP detail wrapper. It will not conflict with Quick Shop modal data.
		var $pdpMain = $('#pdpMain .experience-main-productdetail');
		var $pdpSticky = $('.stick-buy-container');

		$pdpMain.on('click', '#product-content .swatchanchor', function (e) {
			e.preventDefault();
			
			if($(this).closest(".content-pdp").length > 0){//PDP Specific
				var urlLink = Urls.productVariationDetails+"?pid="+$(this).attr("data-mpid")+"&"+$(this).attr("data-varianttype")+"="+$(this).attr("data-variantval")+"&Quantity=1&format=ajax";    	
				urlLink = $("#product-content").parents("#quickview-modal").length > 0 ? urlLink+"&"+$(this).attr("data-cartSrcParam"): urlLink;
				var pid = $(this).attr('data-pid');
				
			}
			else if ($("#product-content").parent().attr("id") != "product-set") {
				var pid = $(this).attr('data-pid');
				var urlLink = this.href;
				
			}
			
			if(urlLink){
				updateContent(urlLink,pid);
			}
			
			
		}).on('change', '#product-content .variation-select', function () {
			if($("#product-content").parent().attr("id") != "product-set"){
				var listItem =  $('#pdp-swatches li[data-selectedcolor="'+ $(this).val() +'"]');
				var link = listItem.find('a.swatchanchor')[0];
				var href = $(link).attr('href');
		
				var $selectedVariantOption = $(this).find("option:selected");
				if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
					return;
				}
				localStorage.removeItem('selColorCat');
				updateContent(href);
			}
		});

		$pdpMain.on("selectmenuchange", "#product-content .variation-select", function (event, ui) {
			if($("#product-content").parent().attr("id") != "product-set"){
				var listItem =  $('#pdp-swatches li[data-selectedcolor="'+ $(this).val() +'"]');
				var link = listItem.find('a.swatchanchor')[0];
				var href = $(link).attr('href');
				var $selectedVariantOption = $(this).find("option:selected");
				if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
					return;
				}
				updateContent(href);
			}
			
		});

		$pdpSticky.on('click', '#pdp-content-sticky .swatchanchor', function (e) {
			e.preventDefault();
			updateContent(this.href);
		});

		$pdpSticky.on("selectmenuchange change", "#pdp-content-sticky .variation-select", function (event, ui) {
			var listItem =  $('#pdp-content-sticky #pdp-swatches li[data-selectedcolor="'+ $(this).val() +'"]');
			var link = listItem.find('a.swatchanchor')[0];
			var href = $(link).attr('href');

			var $selectedVariantOption = $(this).find("option:selected");
			if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
				return;
			}
			updateContent(href);
		});

		$pdpMain.on('click', '.swatchanchor', function (e) { // click event is only for Product Set
			e.preventDefault();
			$('#product-set').length > 0 && updateSetContent($(this), $(this).attr("href"));
		}).on('selectmenuchange change', '.variation-select', function () { // click event is only for Product Set
			if($('#product-set').length > 0 ) {
				var listItem =  $(this).closest(".product-variations").find('.swatches li[data-selectedcolor="'+ $(this).val() +'"]');
				var link = listItem.find('a.swatchanchor')[0];
				var href = $(link).attr('href');
				updateSetContent($(this), href);
			}	
		});

		// change variation based on custom dropdown selection
		$pdpMain.on('click', '#product-content .custom-dd .custom-dd-list-item', function () {
			if($(this).closest(".content-pdp").length > 0){//PDP Specific
				var listItem =  $('#pdp-swatches li[data-selectedcolor="'+ $(this).data("value") +'"]');
				var swatch = listItem.find('div.swatchanchor')[0];
				var urlLink = Urls.productVariationDetails+"?pid="+$(swatch).attr("data-mpid")+"&"+$(swatch).attr("data-varianttype")+"="+$(swatch).attr("data-variantval")+"&Quantity=1&format=ajax";    	
				urlLink = $("#product-content").parents("#quickview-modal").length > 0 ? urlLink+"&"+$(swatch).attr("data-cartSrcParam"): urlLink;
				var pid = $(swatch).attr('data-pid');
			}else{
				var listItem =  $('#pdp-swatches li[data-selectedcolor="'+ $(this).data("value") +'"]');
				link = listItem.find('a.swatchanchor')[0];
				var urlLink = $(link).attr('href');
				var pid = $(link).attr('data-pid');
			}		
			
			// don't change if selected variant clicked			
			if ($(this).hasClass('selected') || $(this).data("value") === '') {
				return;
			}
			
			localStorage.removeItem('selColorCat');
			
			if(urlLink){
				updateContent(urlLink,pid);
			}
		});
		
		updateQuantityOnChange();
		updateReplanishCycle();
		initColorCatFiltersEvents();
		initColorShadesSlider();
		productSetColorSwatchesCarousel();
		initResizeHandler();
		applyTransparentGradient();
		applyTransparentGradientOnScroll();
		scrollToActiveSizeVariant();
		initEinsteinRecommendations();
		resizeStickySidebar();
		$(window).on('resize', function() {
			resizeStickySidebar();
		});
		
		if ($('.swatchanchor').find('.hexcode-unavailable').length > 0 ) {
			var unselectables = document.querySelectorAll('.unselectable');
			unselectables.forEach((unselectable) => {
				unselectable.classList.add('dynamic-width');
			});
			var swatchanchors = document.querySelectorAll('.swatchanchor');
			swatchanchors.forEach((swatchanchor) => {
				swatchanchor.classList.add('dynamic-width');
			});
		}
		if ($('.color-swatch').find('.hexcode-unavailable').length > 0)  {
			var colorswatches = document.querySelectorAll('.color-swatch');
			colorswatches.forEach((colorswatch) => {
				colorswatch.classList.add('dynamic-width');
			});
		}
		if ($('.custom-dd-list-item-selected').find('.hexcode-unavailable').length > 0){
			var colorswatches = document.querySelectorAll('.color-swatch');
				colorswatches.forEach((colorswatch) => {
					colorswatch.classList.add('dynamic-width');
				});
		}
		if ($('.selectable').find('.hexcode-unavailable').length > 0) {
			var selectables = document.querySelectorAll('.selectable');
			selectables.forEach((selectable) => {
				selectable.classList.add('dynamic-width');
			});
		}
		$('.pdp-page #header-bottom-notification-message').length && $('.sticky-sidebar-container').addClass('header-bottom-active');
		customDropdown.init();
	}
}